import React, { Component } from 'react';
import SchemaViewer from '../../elements/schema-viewer/SchemaViewer';

import DateUtils from '../../../lib/DateUtils';
import TagsView from '../../elements/tags/TagsView';
import TagsEditor from '../../elements/tags/TagsEditor';
import DocEditor from '../../elements/editors/DocEditor';
import { RESOURCE_TYPE_SCHEMA_SPECS } from '../../../constants/resourceTypes';

class SchemaSpecOverviewTab extends Component {
  componentDidMount() {
    if (!this.props.hideDocs) {
      this.props.fetchSchemaSpecDoc(this.props.data.id);
    }
  }

  render() {
    const {
      data,
      data: { id, created_at, updated_at, data_samples, flatSamples },
      lastUpdated,
      readOnly,
      doc,
      isLoadingDoc,
      updateSchemaSpecDoc,
    } = this.props;

    let createdDate = DateUtils.convertDateStringToFormat(created_at);
    let lastUpdate = DateUtils.convertDateStringToFormat(updated_at);
    const samplesForDisplay = {
      id,
      lastUpdated,
      samples: flatSamples,
      nestedSamples: data_samples,
    };

    const tagsView =
      readOnly === true ? (
        <TagsView data={this.props.data} />
      ) : (
        <TagsEditor id={id} resourceType={RESOURCE_TYPE_SCHEMA_SPECS} />
      );

    return (
      <div className="tab-content preview-tab">
        <div className="detail-view-two-col">
          <div className="detail-view-main-col">
            {this.props.hideDocs ? null : (
              <DocEditor
                data={data}
                doc={doc}
                isLoading={isLoadingDoc}
                updateDoc={updateSchemaSpecDoc}
              />
            )}
            <h2>Schema & Samples</h2>
            <div className="tab-content preview-tab">
              <SchemaViewer
                schema={this.props.data.flatSchema}
                samples={samplesForDisplay?.samples}
                showCharacteristics={false}
                nestedSamples={samplesForDisplay?.nestedSamples}
                samplesUpdatedAt={samplesForDisplay?.lastUpdated}
                isLoadingSamples={false}
                hideExpandMetaToggle
                resource={this.props.data}
                resourceType={RESOURCE_TYPE_SCHEMA_SPECS}
              />
            </div>
          </div>
          <div className="detail-view-side-col">
            <section style={{ padding: '0 16px' }}>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Resource ID</div>
                  <div className="detail-value">{id}</div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Created On</div>
                  <div className="detail-value">{createdDate}</div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Last Updated On</div>
                  <div className="detail-value">{lastUpdate}</div>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-col">
                  <div className="detail-key">Tags</div>
                  <div className="detail-value">{tagsView}</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default SchemaSpecOverviewTab;
